import ChecklistResourcesSection from "../../../../src/components/ChecklistResourcesSection/ChecklistResourcesSection.jsx";
import * as React from 'react';
export default {
  ChecklistResourcesSection,
  React
};